import { Button, ButtonGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const CheckoutSteps = ({ shippingScreen, orderScreen }) => {
    const navigate = useNavigate();

    const { activeOrder } = useSelector((state) => state.cart);
    const { selectedCompanyRuc } = useSelector((state) => state.cart);
    const companies = activeOrder?.companies || {};
    const cartItems = Array.isArray(companies) 
        ? companies.flatMap(c => c.items || c.orderItems || [])
        : Object.values(companies).flatMap(c => c.items || []);
    const shippingAddress = activeOrder?.shippingAddress || {};

    const activeStyle = {
        backgroundColor: '#b5430f',
        color: 'white',
        borderColor: '#b5430f'
    };

    const inactiveStyle = {
        backgroundColor: '#f8f9fa',
        color: '#6c757d',
        borderColor: '#dee2e6'
    };

    return (
        <ButtonGroup style={{ textAlign: 'center', justifyContent: 'center', display: 'flex' }}>
            <Button
                style={{ 
                    borderBottomLeftRadius: '15px', 
                    borderTopLeftRadius: '15px',
                    ...(inactiveStyle)
                }}
                variant="light"
                onClick={() => navigate('/cart')}
            >
                Carrito
            </Button>
            <Button
                variant="light"
                disabled={!cartItems.length || !selectedCompanyRuc}
                style={shippingScreen ? activeStyle : inactiveStyle}
                onClick={() => navigate('/shipping')}
            >
                Envío
            </Button>
            <Button
                style={{ 
                    borderBottomRightRadius: '15px', 
                    borderTopRightRadius: '15px',
                    ...(orderScreen ? activeStyle : inactiveStyle)
                }}
                variant="light"
                disabled={!shippingAddress.city || !selectedCompanyRuc}
                onClick={() => navigate('/placeorder')}
            >
                Resúmen
            </Button>
        </ButtonGroup>
    );
};
export default CheckoutSteps;
